import api from '../api';
import { postManagerDirectEdit } from '../directEdit/directEditService';

/**
 * Post set-attribute for a single row and attribute (one call per row × attribute).
 * URL is built as {baseUrl}/{rowId}/{attributeId}, body is { value }.
 * @param {string} url - The URL (should include contexte query param via appendContexteToUrl)
 * @param {ApiBatchSetAttributeBodyData} data - The data to send
 * @returns {Promise<ApiBatchSetAttributeSuccessResponse>} The API response on success
 */
export const postSetAttributeForRow = async (url, data) => postManagerDirectEdit(url, data);

/**
 * @param {string} url - The base delete URL
 * @param {string} rowId - The row ID to append
 * @returns {Promise<{ message?: string }>} The response
 */
export const deleteRow = async (url, rowId) => {
  const response = await api.post(`${url}/${rowId}`);
  return response.data;
};
